//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('./BaseMediator')
const ClassFunc = require('../util/ClassFunc')
const DSBridge = require('../../libs/ds-bridge')
const Utils = require('../../utils')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_RefereeMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_RefereeMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_RefereeMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the customized event condition triggered by 
     * the scene instance.
     * @event The event object contains 
     * {type:String, data:Object, target:VueComponent}
     */
    handleCustomizedEvent: function(event) {
        if (event.type == 'invite-referee') {
            this.sendRefereeInvite(event.data, this.convertor())
        }
        else {
            return true
        }
    },
    handleRouteBack: function() {
        if (this._bridge.getRouteName() == 'UserOrgListReferee') {
            this._bridge.goToScene('UserOrgManageOrganization', {id: this._bridge.getRouteQuery('organizationId')})
        }
        else {
            this._bridge.back()
        }
    },
    handleRemoveService: function() {
        this._bridge.goToScene('UserOrgListReferee', {}, {organizationId: this.target().referee.organizationId})
    },
    handleDataLoaded: function() {
        console.log('handleDataLoaded', this._bridge.getRouteQuery('organizationId'))
        this.target().organizationId = this._bridge.getRouteQuery('organizationId')
        // @tmp code 
        // @need polishing for the related picker selectors
        if (this._bridge.isEdit()) {
            const oldGrade = this.target().referee.grade
            this.target().onSportTypeDataChange({value: this.target().referee.sportType})
            this.target().referee.grade = oldGrade
        }
    },
    sendRefereeInvite: function(data, convertor) {
        console.log('sendRefereeInvite', data, convertor)
        const self = this
        self.commitViewObjectData(convertor, {refereeId: data.id, organizationId: data.organizationId}, function(e) {
            console.log('load referee data', e)
            const organization = e.data.payload.data
            const startIndex = location.href.indexOf('/user-org')
            const link = location.href.substr(0, startIndex) + '/user-org/referee/invite/?ticket=' + organization.ticket
            const shareParam = {
                title: convertor.localeProp('member-invite-title', {name: data.name, role: data.roleLabel}),
                desc: organization.accountName,
                imgUrl: Utils.QNImageUtil.imageView(organization.accountLogo, 360, 360),
                link: link
            }
            console.log('share link', shareParam)
            DSBridge.callShare(shareParam)
        }, 'send')
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_RefereeMediator, BaseMediator);

module.exports = tbs_controller_RefereeMediator